import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export const constantRoutes = [
	{
		name: 'subscription',
		path: '/',
		component: () => import('@/views/subscription/NewIndex')
	},
	// {
	//   name: 'NewIndex',
	//   path: '/NewIndex',
	//   component: () => import('@/views/subscription/NewIndex')
	// },
	// 舟海
	{
		name: 'zhzn',
		path: '/zhzn',
		component: () => import('@/views/subscription/zhzn')
	},
	// 中为
	{
		name: 'zw',
		path: '/zw',
		component: () => import('@/views/subscription/zw')
	},
	// 齐沃
	{
		name: 'qw',
		path: '/qw',
		component: () => import('@/views/subscription/qw')
	},
	{
		name: 'qw-test',
		path: '/qw-test',
		component: () => import('@/views/subscription/qw-test')
	},
	{
		name: 'payment',
		path: '/payment',
		component: () => import('@/views/payment/index')
	},
	{
		path: '/order',
		component: () => import('@/views/set/orderPage')
	},
	{
		name: "invoicePage",
		path: '/invoicePage',
		component: () => import('@/views/set/invoicePage')
	},
	{
		name: 'refundPage',
		path: '/refundpage',
		component: () => import('@/views/set/refundPage')
	},
	{
		path: '/unsubscribe',
		component: () => import('@/views/subscription/unsubscribe')
	},
	{
		path: '/language',
		component: () => import('@/views/set/languagePage')
	},
	{
		path: '/problem',
		component: () => import('@/views/set/problemPage')
	},
	{
		path: '/notice',
		component: () => import('@/views/set/noticePage')
	},
	{
		name: "noticeDetail",
		path: '/notice/detail',
		component: () => import('@/views/set/noticeDetail')
	},

	// 隐私政策
	{
		name: 'us',
		path: '/us',
		component: () => import('@/views/policy/us')
	},
	{
		name: 'privacy',
		path: '/privacy',
		component: () => import('@/views/policy/privacy')
	},
	{
		name: 'refund',
		path: '/refund',
		component: () => import('@/views/policy/refund')
	},
	{
		name: 'service',
		path: '/service',
		component: () => import('@/views/policy/service')
	},

	{
		name: 'zhznService',
		path: '/zhznService',
		component: () => import('@/views/policyzhzn/service')
	},
	{
		name: 'zhznPrivacy',
		path: '/zhznPrivacy',
		component: () => import('@/views/policyzhzn/privacy')
	},

	// 新支付 通用主页
	{
		name: 'payHome',
		path: '/xtc/payHome',
		component: () => import('@/views/xtc/payHome')
	},
	{
		name: 'newQw',
		path: '/xtc/qw',
		component: () => import('@/views/xtc/new-qw')
	},
	{
		name: 'oldPayHome',
		path: '/xtc/oldPayHome',
		component: () => import('@/views/xtc/oldPayHome')
	},
	{
		name: 'xtcZhzn',
		path: '/xtc/zhzn',
		component: () => import('@/views/xtc/zhzn')
	},
	{
		name: 'newQwCompatible',
		path: '/xtc/compatible',
		component: () => import('@/views/xtc/compatible')
	},
	// 新支付 蓝精灵
	{
		name: 'ljl',
		path: '/xtc/ljl',
		component: () => import('@/views/xtc/ljl')
	},
	// 小天才 支付网站
	{
		name: 'xtc',
		path: '/xtc',
		component: () => import('@/views/xtc/xtc')
	},
	{
		path: '/xtc/language',
		component: () => import('@/views/xtc/set/languagePage')
	},
	{
		path: '/xtc/notice',
		component: () => import('@/views/xtc/set/noticePage')
	},
	{
		name: "xtcNoticeDetail",
		path: '/xtc/notice/detail',
		component: () => import('@/views/xtc/set/noticeDetail')
	},
	{
		path: '/xtc/problem',
		component: () => import('@/views/xtc/set/problemPage')
	},
	{
		path: '/xtc/unsubscribe',
		component: () => import('@/views/xtc/subscription/unsubscribe')
	},
	{
		path: '/xtc/order',
		component: () => import('@/views/xtc/set/orderPage')
	},
	{
		name: 'xtcRefundPage',
		path: '/xtc/refundpage',
		component: () => import('@/views/xtc/set/refundPage')
	},
	{
		name: 'xtcPayment',
		path: '/xtc/payment',
		component: () => import('@/views/xtc/payment/index')
	},
	{
		name: 'email',
		path: '/xtc/email',
		component: () => import('@/views/xtc/email/index')
	},
]


let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(err => err)
}

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRoutes
})
// 防止连续点击多次路由报错
